import { render } from "./OralPractice.vue?vue&type=template&id=73f6d186&ts=true"
import script from "./OralPractice.vue?vue&type=script&lang=ts"
export * from "./OralPractice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__